"use client";

import Link from "next/link";
import { useLingui } from "@lingui/react";
import { isLocale, localizeHref, DEFAULT_LOCALE } from "@/lib/i18n/locales";
import type { ComponentProps } from "react";

/**
 * Locale-aware Link for marketing chrome: keeps navigation inside /sv when
 * the active locale is Swedish (docs/i18n-plan.md). App/auth/admin hrefs and
 * external URLs pass through untouched (see MARKETING_PATHS). Reads the
 * locale from the Lingui provider, so it works as a leaf under both server
 * and client parents.
 */
export function LocalizedLink({ href, ...rest }: ComponentProps<typeof Link>) {
  const { i18n } = useLingui();
  const locale = isLocale(i18n.locale) ? i18n.locale : DEFAULT_LOCALE;
  const localized = typeof href === "string" ? localizeHref(href, locale) : href;
  return <Link href={localized} {...rest} />;
}
